import React from 'react';
import { ShieldCheckIcon, StethoscopeIcon } from 'lucide-react';
export function VetConnect() {
  return <section aria-labelledby="vet-title" className="mt-10 flex flex-wrap items-center gap-5 rounded-3xl border border-slate-200 bg-slate-50 p-6" data-id="element-248" data-mp="nhcu72htsi5q">
      <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-white text-ville-indigo" aria-hidden="true" data-id="element-249" data-mp="rhmy89m24yhy">
        <StethoscopeIcon className="h-6 w-6" data-id="element-250" data-mp="119j6gdhuy4zw" />
      </span>
      <div className="min-w-0 flex-1" data-id="element-251" data-mp="11917h93t9coa">
        <h2 id="vet-title" className="text-[15px] font-extrabold text-ville-navy" data-id="element-252" data-mp="168nkbhfq8qwk">
          Veterinary services — Vet&amp;Co
        </h2>
        <p className="mt-1 text-sm leading-relaxed text-slate-600" data-id="element-253" data-mp="1b8rxaxhff3i1">
          Connect your pet to your clinic with your consent. You choose which pet and which information is shared.
        </p>
        <p className="mt-2 flex items-center gap-1.5 text-xs text-slate-500" data-id="element-254" data-mp="3d0527mje9be3">
          <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-255" data-mp="3h05htai8bsmq" />
          No health information is shared automatically.
        </p>
      </div>
      <button type="button" className="rounded-full border border-ville-navy px-5 py-2.5 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:bg-ville-navy hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-256" data-mp="3m2a1gn3gd4oz">
        Connect Vet&amp;Co
      </button>
    </section>;
}